import {UniteTemps} from '../model/unite-temps.model';
import {CodeUniteTemps} from './code-unite-temps.enum';

/**
 * Enumération avec les unités de temps disponibles pour la sélection relative des dates
 */
export const UniteTempsEnum: UniteTemps[] = [
	{code: CodeUniteTemps.SECONDE, nom: 'SELECTEUR_DATE.LABEL_UNITE_SECONDES', tempsMillis: 1000},
	{code: CodeUniteTemps.MINUTE, nom: 'SELECTEUR_DATE.LABEL_UNITE_MINUTES', tempsMillis: 60000},
	{code: CodeUniteTemps.HEURE, nom: 'SELECTEUR_DATE.LABEL_UNITE_HEURES', tempsMillis: 3600000},
	{code: CodeUniteTemps.JOUR, nom: 'SELECTEUR_DATE.LABEL_UNITE_JOURS', tempsMillis: 3600000 * 24,}
];
